import translate from '@/utils/translate';

const VALUE_TYPE_PERCENTAGE = 'percentage';
const VALUE_TYPE_FIXED_AMOUNT = 'fixed_amount';

export const NO_VALUE = '—';

export default function discountDisplay(
  value: number | null,
  valueType: string | null
): string {
  if (value == null || Number.isNaN(value)) {
    return NO_VALUE;
  }

  const magnitude = Math.abs(value);

  if (valueType === VALUE_TYPE_PERCENTAGE) {
    return translate('{value} off', {value: `${magnitude}%`});
  }
  if (valueType === VALUE_TYPE_FIXED_AMOUNT) {
    return translate('{value} off', {value: `$${magnitude}`});
  }
  return translate('{value} off', {value: magnitude});
}
